import { createSelector } from 'reselect'

import {
  getParsedDateUntilToday,
  getRangeFromDateFilter,
  HOME_DASHBOARD_DATE_FILTERS,
} from 'utils/dateUtils'
import { checkPerm } from 'utils/permManager'

import { selectActualPermissions, selectSelfPermissions } from 'containers/App/selectors'

export const selectDateFilter = (state) => state.dashboard.home.self.dateFilter

const selectWithoutScanback = (state) => state.dashboard.home.self.withoutScanback

const selectDateRangeDummy = (state) => state.dashboard.home.self.feDateRange

const selectDateRange = createSelector(
  selectDateRangeDummy,
  selectDateFilter,
  (feDateRange, dateFilter) =>
    feDateRange || getRangeFromDateFilter(dateFilter, false, HOME_DASHBOARD_DATE_FILTERS)
)

const selectParsedDate = (state) => {
  const currentDateFilter = selectDateFilter(state)
  return getParsedDateUntilToday(currentDateFilter)
}

const selectIncidentsWidgetsVisibility = createSelector(selectSelfPermissions, (selfPermissions) =>
  checkPerm(selfPermissions, ['admin', 'irontraps_action', 'manage_irontraps', 'irontraps_viewer'])
)

const selectHasIncidentWidgetAccess = createSelector(selectActualPermissions, (actualPermissions) =>
  checkPerm(actualPermissions, [
    'admin',
    'irontraps_action',
    'manage_irontraps',
    'irontraps_viewer',
  ])
)

export {
  selectDateRange,
  selectParsedDate,
  selectWithoutScanback,
  selectIncidentsWidgetsVisibility,
  selectHasIncidentWidgetAccess,
}
